import React, { use } from 'react'
import { useState, useEffect } from 'react'
import AdsService from '../../../../services/Ads';
import { useNavigate } from 'react-router';
import Fcard from "./modal/Fcard";
import { useDispatch } from 'react-redux';
// import { showToast } from '../../../redux/slices/toastSlice';
import EmptyStateMyLoads from '../../../../Modals/empty list/EmptyList';
import FavoritesSkeleton from './FavoritesSkeleton';


const AllFavorites = () => {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(true)


    //get all favorites
    async function getAllFavorites() {
        setLoading(true);
        try {

            const res = await AdsService.likedAds()
            setAllFavorites(res?.data?.data)

        } catch (err) {
            console.log(err)
        }
        finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        getAllFavorites()
    }, [])

    const [allFavorites, setAllFavorites] = useState([])
    const navigate = useNavigate()

    if(loading) return <FavoritesSkeleton />

    return (
        <>
            {

                allFavorites?.length == 0 ?
                    <EmptyStateMyLoads

                        colorContent="text-special"
                        title="لیست علاقه مندی خالی است"
                        subtitle="تاکنون باری را ذخیره نکرده اید."
                        onCta={() => { navigate("/ads") }}
                        ctaText="مشاهده لیست آگهی ها"
                    />

                    :
                    <div className="flex flex-col items-start justify-start  w-full lg:h-[calc(100vh-10rem)] overflow-y-auto ">

                        <Fcard allFavorites={allFavorites || []}></Fcard>

                    </div>
            }

        </>
    )
}

export default AllFavorites
